export default "__VITE_ASSET__rvMEV$DU__"